import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { cities, extraAreas } from '../../data/cities';
import { SectionHeading } from '../ui/SectionHeading';
export function ServiceAreasGrid() {
  const {
    t,
    b
  } = useLanguage();
  return <section id="service-areas" className="scroll-mt-24 bg-mist py-20 md:py-24" aria-labelledby="areas-title" data-id="element-340" data-mp="mqjhrois4wmd">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8" data-id="element-341" data-mp="3v63566wrrkti">
        <SectionHeading id="areas-title" title={t('areas.title')} subtitle={t('areas.sub')} data-id="element-342" data-mp="3qaxmri2ksoa6" />

        <ul className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-343" data-mp="7w6k26yajvda">
          {cities.map(city => <li key={city.slug} data-id="element-344" data-mp="333qvzxfenxm">
              <Link to={`/service-areas/${city.slug}`} className={['group flex h-full flex-col rounded-lg border bg-white p-5 transition-[transform,border-color,box-shadow] duration-200 ease-smooth hover:-translate-y-1 hover:shadow-lg', city.homeBase ? 'border-cta' : 'border-navy/10 hover:border-brand-700'].join(' ')} data-id="element-345" data-mp="3bkgm40xrm2ec">
                <div className="flex items-start justify-between gap-2" data-id="element-346" data-mp="2jhgveuaw6hv6">
                  <MapPinIcon className={city.homeBase ? 'h-5 w-5 text-cta' : 'h-5 w-5 text-brand-700'} aria-hidden="true" data-id="element-347" data-mp="2oh3idvgivch6" />
                  {city.homeBase && <span className="rounded-full bg-cta/10 px-2.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide text-cta-dark" data-id="element-348" data-mp="1vrwa44r9n8iq">
                      {t('areas.homeBase')}
                    </span>}
                </div>
                <h3 className="mt-4 font-display text-lg font-bold text-navy" data-id="element-349" data-mp="25rwy4402yct9">{city.name}, WA</h3>
                <p className="text-sm text-ink-muted" data-id="element-350" data-mp="3c6ecwv7a4amv">{b(city.county)}</p>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-351" data-mp="3h4phoripvuy8">{b(city.responseTime)}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-bold text-brand-700" data-id="element-352" data-mp="1h27x5in4sz79">
                  {t('areas.viewArea')}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-353" data-mp="1q47c85el5t7k" />
                </span>
              </Link>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-sm text-ink-muted" data-id="element-354" data-mp="yanep9gpq77k">
          <span className="font-semibold text-navy" data-id="element-355" data-mp="tfhwakmirao8">{t('areas.alsoServing')}:</span> {extraAreas.join(' · ')}
        </p>
      </div>
    </section>;
}